import { gql } from '@apollo/client';

export const GET_PATIENT_GROUPS_PAGINATION = gql`
  query GetPatientGroup(
    $page: Int!
    $perPage: Int!
    $filter: GqlPatientGroupsFilter
  ) {
    patientGroup {
      patientGroupsPage(page: $page, perPage: $perPage, filter: $filter) {
        pageInfo {
          totalItems
          page
          perPage
          totalPages
          hasNextPage
          hasPreviousPage
        }
        items {
          id
          title
          careTeamId
          careTeam {
            id
            name
          }
          patientIds
          patientsTotalCount
        }
      }
    }
  }
`;
